<template>
  <Layout>
    <section class="mcp-wrap">
      <div class="mcp-content">
        <div class="container pt-5">
          <div class="row">
            <div class="col-md-5 d-flex align-items-center">
              <b-card no-body>
                <b-card-body>
                  <h4 class="header-title">Place your ads anywhere</h4>
                  <div class="mb-2">
                    <p class="header-text">
                      Enables marketers and business brands to place their printed ads to the entire network of <a href="https://www.peddlr.io" target="_blank" class="text-primary">Peddlr's</a> micro and small stores around the country.
                    </p>

                    <!-- <search-segment 
                      v-model="addressFilter.regions" 
                      :options="regionOptions" 
                      segmentName="Region" 
                      :disabled="regionOptions.length == 0"
                      id="region">
                    </search-segment> -->
                  </div>
                  <!-- <b-button class="btn-sm btn-block w-100" variant="primary" :disabled="isSearching" @click="search('reset')"
                    >
                    <span
                      v-if="isSearching"
                      class="spinner-grow spinner-grow-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <img src="@/assets/images/magnifying-glass.png" />
                    Search</b-button
                  > -->
                </b-card-body>
              </b-card>
            </div>
            <div class="col-md-6  offset-md-1">
              <div class="d-flex justify-content-center">
                <img src="@/assets/images/browse-space/embay-store 1.png" class="img-fluid">
              </div>
            </div>
          </div>
        </div>
        <div class="wave-effect">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" class="shape-fill"></path>
            </svg>
            <!-- <svg width="1278" height="221" viewBox="0 0 1278 221" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M960.014 50.6031C864.295 50.9456 623.287 44.1489 425.014 14.2215C247.178 -12.621 80.8733 4.05775 0 19.2013V221H1284V50.6031H960.014Z" fill="white"/>
            </svg> -->

        </div>
      </div>
    </section>

    <!-- <section class="">
      <filter-header  @update="onFilterUpdate"/>
    </section>

    <section class="pt-2 bg-white" style="padding-bottom: 10%;">
      <div class="container pt-4">
        <diV class="d-flex row">
          <div class="col-12">
            <h3 class="fw-bold">Available Rental Spaces</h3>
            <hr style="height: 3px;background-color: #F84B04; opacity: 1; width:3%; border:0;">
            <p>Search Result: <b>{{regionList}}</b></p>
          </div>
          <div  v-if="list.length > 0" class="listing-container col-12">
            <b-row class="w-100">
              <b-col sm="12" md="6" lg="4" xl="4" :key="index" v-for="(item, index) in list" class="c-pointer mb-4">
                <grid-item v-model="list[index]" @viewPublic="openModal('bv-modal-login')"/>
              </b-col>
            </b-row>
          </div>
          <div v-if="list.length == 0" class="d-flex text-center w-100 no-store-container flex-column">
            <img class="store-icon align-self-center mb-2" src='@/assets/images/store-search.png' />
            <div class="no-stores-text">No store available</div>
          </div>

          <div class="col-12 d-flex justify-content-center" v-if="list.length < listinTotalRows">
            <button type="button" class="btn btn-outline-primary" @click="openModal('bv-modal-login')">Show More Spaces</button>
          </div>
        </div>
      </div>
      <b-modal id="bv-modal-login" title="Login" size="md" hide-header hide-footer centered>
        <span class="float-end c-pointer" @click="closeModal('bv-modal-login')"><i class="bx bx-x"></i></span>
        <div class="row p-2">
          <div class="col-12 d-flex align-items-center justify-content-center">
            <i style="font-size: 100px;" class="bx bx-user-circle text-primary"></i>
          </div>
          <div class="col-12 text-center">
            <p style="font-family: Poppins;
              font-size: 24px;
              font-weight: 500;
              ">Oops! You need to be logged in</p>
            <p style="font-family: Roboto;
              font-size: 14px;
              ">You need to log in or create an account to continue.</p>
              <router-link :to="{ name: 'login', params: {} }">
                <button type="button" class="btn btn-primary w-100 btn-block" >Log in now</button>
              </router-link>
            <p class="mt-2">
              <span class="me-1">Don't have an account yet?</span>

              <router-link :to="{ name: 'register', params: {} }">
                <a href="#" class="text-primary">Create your account</a>
              </router-link>
            </p>
          </div>
        </div>
      </b-modal>
    </section> -->

    <section>
      <div class="mcp-footer d-flex justify-content-between">
        <div class="float-start">
          <img class="filter-icon mb-2" src="@/assets/images/kanto-logo-sm.png" width="45">
          <span>Copyright &copy; 2023 Kanto Ads. All Rights Reserved</span>
        </div>
        <div class="float-end ta-right">
          <button type="button" class="btn btn-link" @click="openModal('bv-modal-privacy-policy')">Privacy Policy</button>
          <button type="button" class="btn btn-link" @click="openModal('bv-modal-terms-conditions')" v-if="false">Terms & Condition</button>
        </div>
      </div>

      <b-modal id="bv-modal-privacy-policy" title="Privacy Policy" size="lg" hide-header hide-footer hide-header-close>
        <div class="pp-wrap">
          <div class="pp-content text-justify" style="padding: 0px 5%;">
            <span class="float-end c-pointer" @click="closeModal('bv-modal-privacy-policy')"><i class="bx bx-x"></i></span>
            <h2 class="text-center">PRIVACY NOTICE</h2>
            <p class="ts-13">
              Welcome to KantoAds run by Peddlr Philippines, Inc and its affiliates. KantoAds is committed to comply with the applicable privacy laws 
              and regulations (“Privacy Laws”) under the Republic Act 10173 or the Data Privacy Act of 2012 (DPA) in order to protect and respect the 
              rights and concerns of all users of KantoAds Website. We recognize the importance of the personal data you entrusted us, and we believe 
              that it is our responsibility to properly manage, protect, and process such personal data. We are committed in upholding the privacy 
              rights and addressing privacy-related concerns of all the Users of our KantoAds Website.
            </p>
            <p class="ts-13">
              By using KantoAds, you hereby consent us to process your personal data upon registering an account, visiting the Platform, and accessing 
              the Services. We will/may collect personal data about you upon: 
            </p>
            <ul class="ts-13">
              <li>Registration and/or Use the Services or Platform, or opening an account with KantoAds.</li>
              <li>Submission of any form, including, but not limited to, application forms or other forms relating to any of KantoAds' products and services, whether online or by way of a physical form. </li>
              <li>Entering into any agreement or providing other documentation or information in respect of its interactions with KantoAds, or use of its products and services. </li>
              <li>Interaction with KantoAds, such as via telephone calls, social media platforms and emails, including interaction with KantoAds' customer service agents. </li>
              <li>Utilization of the electronic services or interaction with KantoAds via its application or use services on its Platform, including the cookies deployed while interacting with KantoAds’ application or website. </li>
              <li>Giving permission to KantoAds to be installed in a device to share information with KantoAds' application or Platform. </li>
              <li>Linking KantoAds account with the social media or other external account or other use of social media features. </li>
              <li>Carrying out transactions through KantoAds' Services. </li>
              <li>Providing KantoAds with feedback or complaints. </li>
              <li>Registration for a contest. </li>
              <li>Voluntarily submission of personal data in connection with the application or Services of KantoAds. </li>
            </ul>
            <p class="ts-13">
              If you do not consent KantoAds to process your personal data, we recommend to not use or access our platform. 
            </p>
            <hr>

            <p class="ts-13">
              <b>1. WHAT PERSONAL DATA WILL KANTOADS COLLECT? </b><br>
              <span>The personal data that KantoAds may collect includes but is not limited to:</span>
            </p>
            <ul>
              <li>Mobile Number </li>
              <li>Business Name </li>
              <li>Business Address </li>
              <li>Nature of Business </li>
              <li>Name</li>
              <li>Account Email Address </li>
              <li>Business Mobile Number </li>
              <li>Device’s Internet Protocol (IP) address </li>
              <li>Computer/mobile device operating system and browser type </li>
              <li>Type of mobile device </li>
              <li>The characteristics of the Mobile device </li>
              <li>The unique device identifier (UDID) </li>
              <li>Mobile equipment identifier (MEID) for the mobile device </li>
              <li>The address of a referring web site (if any) </li>
              <li>The pages visited on the website and mobile applications and the times of visit </li>
              <li>A "cookie" </li>
            </ul>
            <p class="ts-13">
              If you linked KantoAds to an External Account, KantoAds may access your account and personal data provided you consent 
              to the Privacy Policy and Terms of Service of KantoAds and linked external account. 
            </p>
            <p class="ts-13">
              Our authorized service providers and advertising partners may, from time-to-time, use "cookies" to improve our Platform 
              and the Services we offer. You may refuse the use of cookies through your browser or device, but you may not be able to 
              use the full functionality of our Platform or the Services.
            </p>
            <p class="ts-13">
              In conducting our business, our third-party service providers, agents and/or our affiliates or related corporations, 
              and/or other third parties may need to use, process, disclose, and/or transfer your personal data—limited to the purposes 
              listed below. We endeavor to ensure that the third parties and our affiliates keep your personal data secure from any 
              violation under the regulations of DPA 2012.
            </p>
            <hr>

            <p class="ts-13">
              <b>2.  HOW DO WE USE THE INFORMATION YOU PROVIDE US?</b><br>
              <span>KantoAds processes your personal data for the following purposes:</span>
            </p>
            <ul>
              <li>Improve your experience using our Platform and Service </li>
              <li>Improve and create customized products to meet your preferences and needs </li>
              <li>Enable communication for relevant products and/or advisories </li>
              <li>Promote ads on our services and send ads of our services </li>
              <li>Determine the impact and reach of ads services </li>
              <li>Enable us to process information for statistical, analytical, and research purposes to produce anonymous and complete reports </li>
              <li>Mobile</li>
            </ul>
            <hr>

            <p class="ts-13">
              <b>3. HOW DOES KANTOADS PROTECT AND RETAIN CUSTOMER INFORMATION? </b><br>
              <span>The user's personal data is contained behind secured networks and only a limited number of employees have special access 
                rights to such systems. We will destroy or anonymize your personal data when we have reasonably determined that (i) the purpose for 
                which that personal data was collected is no longer being served by the retention of such personal data; (ii) retention is no longer 
                necessary for any legal or business purposes; and (iii) no other legitimate interests warrant further retention of such personal data. 
                If you decide to deactivate or withdraw your permission to use the Platform, all personal data gathered shall be retained by KantoAds 
                for a minimum period of five (5) years. In accordance to DPA 2012, Your personal data will be disposed in a secure manner preventing 
                further processing, unauthorized access, or disclosure to any other parties. </span>
            </p>
            <hr>

            <p class="ts-13">
              <b>4. HOW CAN YOU WITHDRAW CONSENT, REQUEST ACCESS TO, OR CORRECT INFORMATION YOU HAVE PROVIDED TO US?</b>
            </p>
            <p class="ts-13">
              <span class="iu">Withdrawing Consent</span><br>
              <span>
                You have the right to suspend, withdraw, or order the blocking, removal, or destruction of your Personal Data in our 
                processing systems upon discovery that your Personal Data is no longer necessary for the purpose or purposes for which 
                it was collected, and for such other cases provided in the Data Privacy Act of 2012 by sending an email to our Personal 
                Data Protection Officer at <a href="mailto:kantoads@peddlr.io" target="_blank">kantoads@peddlr.io</a>. 
              </span>
            </p>
            <p class="ts-13">
              <span class="iu">Requesting Access to or Correction of Personal Data </span><br>
              <span>
                If you have an account with us, you may personally access and/or correct your personal data currently in our possession or control 
                through the Account Settings page on the Platform. If you do not have an account with us, you may request to access and/or correct 
                your personal data currently in our possession or control by submitting a written request to our Personal Data Protection Officer 
                at <a href="mailto:security@peddlr.io" target="_blank">security@peddlr.io</a>, subject to identity verification and/reasonable fee for 
                proper handling and processing of your requests. 
              </span>
            </p>
            <hr>

            <p class="ts-13">
              <b>5. If you have any questions about this privacy notice, you can contact us: </b><br>
              <span>
                By visiting this page on our website: <a :href="navHomeAboutRootUrl" target="_blank">{{ navHomeAboutRootUrl }}</a>
              </span><br>
              <span>
                By sending us an email: <a href="mailto:kantoads@peddlr.io" target="_blank">kantoads@peddlr.io</a>
              </span><br>
            </p>
          </div>
        </div>
      </b-modal>

      <b-modal id="bv-modal-terms-conditions" title="Terms & Condition" size="lg" hide-header hide-footer hide-header-close>
        Terms & Condition
      </b-modal>
    </section>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/main.vue";
// import GridItem from "@/views/pages/listings/grid-item";
// import FilterHeader from "@/views/pages/listings/filter-header";
// import FilterCarousel from "@/views/pages/listings/filter-carousel";
// import TagList from "@/components/tag-list";
import { listingComputed, listingMethods, addressMethods, addressComputed } from "@/state/helpers";
// import SearchSegment from "@/components/search-segment";
import _ from "lodash";

export default {
  components: {
    Layout,
    // GridItem,
    // FilterHeader,
    // SearchSegment
  },
  computed: {
    ...listingComputed,
    ...addressComputed,
    regionOptions: {
      get(){
        return this.regions.map((r) => {
          return {
            id: r.regionId,
            name: r.regionName,
            storeCount: r.storeCount ?? 10,
            isSelected: false
          }
        });
      }
    },
    filters: {
      get(){
        return {
          landmarks: this.otherFilters.map(l => l.name),
          addresses: this.addressFilter.regions.map(r => r.name)
        }
      }
    },
    navHomeAboutRootUrl() {
      if (typeof process !== 'undefined' && process.env && process.env.VUE_APP_NAV_HOMEABOUT_ROOT_URL) {
        return process.env.VUE_APP_NAV_HOMEABOUT_ROOT_URL;
      }
      return '/';
    }
  },
  watch: {
    'addressFilter.regions': {
      handler(val) {
        console.log(val)
        this.fetchProvinces({ 
          regionId: val.map(r => r.id).join(','), 
          storeCount: 1 
        });
        this.$emit('input', this.addressFilter);
      },
      deep: true,
    }
  },
  methods: {
    ...listingMethods,
    ...addressMethods,
    search(type = null){
      this.isSearching = true;
      if(type == "increment"){
        this.page++; 
      }
      else if(type == "reset"){
        this.page=1; 
        this.list=[]; 
      }
      this.params = _.cloneDeep(this.filters);

      var params = {
        status: ['available','sold'],
        order: 'priority',
        ...this.params
      }

      this.fetchPublicListings(params).then((res)=>{
        this.isSearching = false;
        this.list = res.rows;//this.list.concat(res.rows);
        console.log(this.params);
        this.regionList = this.params.addresses.join(', ');
      }).catch(() => { this.isSearching = false });
    },
    onFilterUpdate(item){
      console.log('filter update');
      // console.log(">>> ehy",item);
      if(this.list.length > 0){
        for(let i of item){
          i.isSelected = false;
        }
        return this.openModal('bv-modal-login');
      }
      this.otherFilters = item.filter(i => { return i.isSelected});
      // console.log(this.otherFilters);
      this.search('reset');
    },
    openModal(modal=''){
      this.$bvModal.show(modal)
    },
    closeModal(modal=''){
      this.$bvModal.hide(modal)
    },
  },
  async mounted() {
    this.fetchRegions({ storeCount: 1 });
    // this.search();
  },
  data() {
    return {
      isSearching: false,
      regionList: '',
      addressFilter: {
        regions: [],
      },
      otherFilters: {
        landmarks: []
      },
      page: 1,
      rows: 9,
      params: {},
      selectedItem: [],
      list: []
    };
  },
};
</script>

<style>
.address-segment-container {
  border: 1px solid #e6eaf1;
  padding: 10px;
  border-radius: 8px;
}

.header-text{
  font-family: 'Poppins';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.03em;
  text-align: left;
}
.header-title{
  font-family: 'Poppins';
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0.03em;
  text-align: left;
}

.mcp-wrap {
  position: relative;
}

.mcp-wrap:before {
  content: ' ';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  background-image: url('/browse-space/bg1.png');
  background-repeat: no-repeat;
  background-position: 50% 0;
  background-size: cover;
}

.mcp-content {
  position: relative;
}

section{
  position: relative;
  display: flex;
  flex-direction: column;
  /* padding: 100px 20vw; */
}

.wave-effect {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    line-height: 0;
    transform: rotate(180deg);
}

.wave-effect svg {
    position: relative;
    display: block;
    width: calc(119% + 1.3px);
    height: 51px;
}

.wave-effect .shape-fill {
    fill: #FFFFFF;
}
.popover {
  max-width: 700px;
  background: none;
  border: none;
}
.popover-body {
  margin-top: 10%;
  background: #FFF;
  border-radius: 5px;
}

.store-icon {
  width: 50px;
}

.no-store-container {
  padding-top: 40px;
  padding-bottom: 40px;
  color: #ACADAF;
  font-size: 20px;
}

.mcp-footer{
  padding: 20px 10%;
  background: #FAFAFA;
}

.mcp-footer .btn-link{
  color: #000;
  text-decoration: underline;
}

.iu{
  text-decoration: underline;
  font-style: italic;
}
.text-justify {
  text-align: justify;
}

.pp-wrap {
  position: relative;
}

.pp-wrap:before {
  content: ' ';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.2;
  background-image: url('/favicon.ico');
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 15%;
}

.pp-content {
  position: relative;
}

.bg-white{
  background: #fff;
}
</style>